import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/Careers.css";

export const Careers = ({ data }) => {
  const navigate = useNavigate(); // Use navigate for redirection

  return (
    <div className="careers-page">
      <div className="hero-section">
        <div className="hero-text">
          <h1>WE ENRICH YOUR LIFE</h1>
          <p>
            At Deft Technologies, we are driven by a passion for innovation and
            excellence, committed to helping businesses across Africa unlock
            the full potential of Microsoft Dynamics 365. Our team thrives on
            delivering impactful solutions that foster efficiency and growth.
            Joining Deft means becoming part of a dynamic, results-oriented
            company where your contributions matter.
          </p>
        </div>
      </div>

      <div className="careers-content container">
        <div className="latest-jobs">
          <h2>LATEST JOBS</h2>
          <p className="sub-title">
            Join our team and help us deliver the best solutions for our
            clients.
          </p>
          {data && data.length > 0 ? (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Job Title</th>
                    <th>Description</th>
                    <th>Deadline</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((job) => (
                    <tr key={job.id}>
                      <td>{job.title}</td>
                      <td>{job.description.substring(0, 50)}...</td>
                      <td>{job.deadline}</td>
                      <td>
                        <button
                          className="view-more-btn"
                          onClick={() => navigate(`/careers/${job.id}`)}
                        >
                          View More
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="no-jobs">
              There are no vacancies available at the moment. Keep checking our
              site for new job openings.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
